import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";

/* Components */ 
import Base from './pages/base';
import Access from './pages/access';

/* Styles */
import "../css/app.less";

var mySessKey = "y0ung_tro";
const baseUrl = (window.location.href.indexOf("localhost") > -1 ? "http://localhost:3001" : "");

class App extends Component{
    constructor(props) {
        super(props);
        this.state = {
            user: null,
            init: false
        }

        this.checkUser = this.checkUser.bind(this);
        this.userHandler = this.userHandler.bind(this);
        this.setInit = this.setInit.bind(this);
        this.getInit = this.getInit.bind(this);
    }

    checkUser(updateDt, parse){
        try {
            var ret = null;
            var sessionInfo = localStorage.getItem(mySessKey);
            
            if(sessionInfo && sessionInfo[0] === "{") {
                localStorage.removeItem(mySessKey);
                jAuth.signout();
            }
            else if(sessionInfo){
                var { localUser, isExpired } = parseToken(sessionInfo);

                if(!isExpired){
                    if(updateDt){
                        // Verify User
                        // Set New LocalStorage
                    }
                    
                    ret = (parse ? localUser : sessionInfo); 
                    jAuth.authenticate(() => { });                    
                }
                else {
                    localStorage.removeItem(mySessKey);
                    this.setState({ user: null }, () => { jAuth.signout(); });
                }
            }
        }
        catch(ex){
            console.log( " [Error] Checking User: ",ex);
        }

        return ret;
    }

    userHandler(newToken, cb) {
        var self = this;
        try {   
            var usr = null;
            if(newToken){
                var { localUser, isExpired } = parseToken(newToken);                

                if(!isExpired) { usr = localUser; }
            }   

            self.setState({ user: usr },() => {
                if(!self.state.user){
                    localStorage.removeItem(mySessKey);
                    cb();
                } 
                else {
                    localStorage.setItem(mySessKey, newToken);
                    jAuth.authenticate(cb);
                }
            });          
        }
        catch(ex){
            console.log("Error with user Handler: ", ex);
        }
    }
    
    setInit(){
        try {
            this.setState({ init: true });
        }
        catch(ex){
            console.log("[Error] Toggling Init: ",ex);
        }
    }

    getInit(){
        try {
            return this.state.init;
        }
        catch(ex){
            console.log("[Error] Getting Init: ",ex);
        }
    }

    componentDidMount(){ this.checkUser(true); }

    render(){   
        return(
            <Router>
                <Switch>
                    <Route path="/access">
                        <Access userHandler={this.userHandler} baseUrl={baseUrl}/>
                    </Route>
                    <PrivateRoute path="/">
                        <Base userHandler={this.userHandler} baseUrl={baseUrl} checkUser={this.checkUser} getInit={this.getInit} setInit={this.setInit} />
                    </PrivateRoute>
                </Switch>
            </Router>
        );
    }
}

export default App;


const jAuth = {
    isAuthenticated: false,
    checkUser() {
        //var ret = true;
        var ret = false;
        try {
            var sessionInfo = localStorage.getItem(mySessKey);
            if(sessionInfo){
                //var localUser = JSON.parse(sessionInfo);
                var { localUser } = parseToken(sessionInfo);
                ret = (localUser.userId ? true : false);
            }
        }
        catch(ex){
            console.log(" [Error] jAuth check: ",ex);
        }
        jAuth.isAuthenticated = ret;
        return ret;
    },
    authenticate(cb) {
        jAuth.isAuthenticated = true;
        cb();
    },
    signout() {
        jAuth.isAuthenticated = false;
    }
};

function PrivateRoute({ children, ...rest }) {
    var authChk = jAuth.checkUser();
    return (
      <Route {...rest} render={({ location }) =>
            authChk ? (children) 
            : ( <Redirect to={{ pathname: "/access", state: { from: location } }}/> )
        }/>
    );
}

function parseToken(token){
    var localUser = null, isExpired = true; 
    try {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace('-', '+').replace('_', '/');
        var jsStr = window.atob(base64);

        localUser = JSON.parse(jsStr);
        isExpired = (localUser && localUser.expDt < Date.now());
    }
    catch(ex){
        console.log("[Error] parsing token: ",ex);
    }

    return { localUser, isExpired }
}